import { Col, Container, Image, Row } from 'react-bootstrap';
import AnanthImage from 'assets/img/landing/experts/ananth.jpg';
import AshokImage from 'assets/img/landing/experts/ashok.jpg';
import NatrajanImage from 'assets/img/landing/experts/natrajan.jpg';
import DhanalakshmiImage from 'assets/img/landing/experts/dhanalakshmi.jpg';
import ShankariImage from 'assets/img/landing/experts/shankari.jpg';
import ManikandanImage from 'assets/img/landing/experts/manikandan.jpg';
import VenkateshImage from 'assets/img/landing/experts/venkatesh.jpg';

const expertsData = [
  {
    firstName: 'Ananth',
    lastName: 'Arumugasamy',
    role: 'Chief Executive Officer',
    image: AnanthImage
  },
  {
    firstName: 'Ashok',
    lastName: 'Arumugasamy',
    role: 'Chief Operating Officer',
    image: AshokImage
  },
  {
    firstName: 'Natrajan',
    lastName: 'Veerasekaran',
    role: 'Chief Technology Officer',
    image: NatrajanImage
  },
  {
    firstName: 'Manikandan',
    lastName: 'Shivashanmugavel',
    role: 'Chief Strategy Officer',
    image: ManikandanImage
  },
  {
    firstName: 'Dhanalakshmi',
    lastName: 'Lakshmanan',
    role: 'Chief Financial Officer',
    image: DhanalakshmiImage
  },
  {
    firstName: 'Sangari',
    lastName: 'Udhayasuriyan',
    role: 'Chief Administrative Officer',
    image: ShankariImage
  },

  {
    firstName: 'Venkatessh',
    lastName: 'Baskaran',
    role: 'Chief Growth Officer',
    image: VenkateshImage
  }
];

function Experts() {
  return (
    <Container className="pb-14 bg-body-highlight px-lg-14" fluid>
      <p className="fs-4 fw-bold text-center">
        Meet Our <span className="text-secondary-light">Leadership</span>{' '}
      </p>
      <p className="fs-9 text-center mb-0">
        Meet the trailblazers behind CRUD Beat—a team of visionaries shaping the
        future with innovation, expertise,
      </p>
      <p className="fs-9 text-center mb-12">
        {' '}
        and an unwavering drive to create groundbreaking solutions that redefine
        success.
      </p>
      <Row>
        {expertsData.map((data, index) => (
          <Col lg={3} key={`expert-${index}`} className="p-lg-0 p-md-0 p-4">
            <Image src={data.image} alt="expertsImage" width="100%" />
            <p className="text-body-quaternary mb-0 mt-2">
              <span className="text-secondary-dark fw-semibold pe-1">
                {data.firstName}
              </span>
              {data.lastName}
            </p>
            <p>{data.role}</p>
          </Col>
        ))}
      </Row>
    </Container>
  );
}

export default Experts;
